import React from 'react'
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined'

const IconComponent = (): any => {
  return <CheckOutlinedIcon color='success' className='onerem' />
}

export default IconComponent
